export default "__VITE_ASSET__XOsgyBI___"